import React from 'react';
import ProgramAddEditModal from './program-add-edit';
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { PROGRAM_ADD_EDIT } = MODAL_TYPES;

const PlannerModals = () => {
  return (
    <>
      <ProgramAddEditModal modalId={PROGRAM_ADD_EDIT} />
    </>
  );
};

export default PlannerModals;
